import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';

const MedicalCriteria2 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingStore: { productLines, cart, setCurrentProductLineId },
    browsingFilterStore: { onBrowsingCriteriaChange, getBrowsingCriteriaValue },
    browsingCriteriaModalStore: { openBrowsingCriteriaModal },
  } = useRootStore();

  const convertedProductLines = productLines.map((line) => toJS(line)).slice();
  const convertedCart = toJS(cart);

  const bcName = 'metallicLevel_FILTER';

  const openBcModal = (): void => {
    const selectedProductLineId = 'GroupMedical';

    setCurrentProductLineId(selectedProductLineId);
    const pLine = convertedProductLines.find((line) => line.productLineId === selectedProductLineId);
    void openBrowsingCriteriaModal(
      convertedCart,
      selectedProductLineId,
      pLine?.eStoreBcFormId || pLine?.bcFormId || '',
      {
        insuranceType_FILTER: getBrowsingCriteriaValue('insuranceType_FILTER'),
        metallicLevel_FILTER: 'Bronze',
        compatibility_FILTER: 'Traditional',
      },
    );
  };

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'Platinum',
      label: "I'm willing to pay for the most coverage possible",
      value: 'Platinum',
    },
    {
      id: 'Gold',
      label: "I'm looking for above average coverage but hide the most expensive plans",
      value: 'Gold',
    },
    {
      id: 'Silver',
      label: "I'm looking for good value, a mix of affordability and coverage",
      value: 'Silver',
    },
    {
      id: 'Bronze',
      label: 'We have young, generally healthy employees - show me the most affordable plans',
      value: 'Bronze',
    },
  ];

  return (
    <div>
      <TextBlock title="Metallic Level" subtitle="How would you describe the level of coverage you are looking for?" />
      <RadioGroup
        label=""
        value={getBrowsingCriteriaValue(bcName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onBrowsingCriteriaChange(bcName, e.target.value);
          if (e.target.value === 'Bronze') {
            openBcModal();
          }
        }}
      />
    </div>
  );
});

export default withCriteria(MedicalCriteria2, 2);
